import type { DerbyState } from '@/entities/derby';
import { RADIUS, Squircle, StaticSquircle } from '@/shared/ui';

import { DerbyResultArt, DerbyResultCard } from './DerbyResult';
import styles from './DerbyResultModal.module.scss';

interface DerbyResultModalProps {
  derby: DerbyState;
  onClose: () => void;
}

/**
 * Результат уже пройденного Дерби, открытый из промо-карточки (узел
 * 438:51717) — не со страницы /derby (там тот же блок показывается сразу
 * после последнего вопроса, см. widgets/derby-quiz/ui/DerbyQuiz.tsx), а
 * когда игрок вернулся позже и жмёт на карточку с кнопкой «Результат»
 * (аннотация в макете: «Когда ДЕРБИ пройдено, то в карточке кнопка
 * меняется на результат и мы открываем модалку с результатом»).
 */
export function DerbyResultModal({ derby, onClose }: DerbyResultModalProps) {
  return (
    <div className={styles.overlay}>
      <div className={styles.sheet} data-testid="derby-result-modal">
        {/* Метки нужны e2e: зазор между этими двумя группами задан макетом
            (43px) и обязан быть нижней границей, а не остатком высоты */}
        <div className={styles.topGroup} data-testid="derby-result-top">
          <DerbyResultArt />

          {/* Крестик в углу 56px-зоны поверх кляксы — узел 725:6057:
              белый квадрат 24×24 со скруглением и тёмной иконкой внутри,
              тот же компонент, что у шеврона статистики (403:7123). */}
          <StaticSquircle asChild width={24} height={24} cornerRadius={RADIUS.sm}>
            <button type="button" className={styles.close} aria-label="Закрыть" onClick={onClose}>
              <img className={styles.closeIcon} src="/images/matches/close.svg" alt="" aria-hidden />
            </button>
          </StaticSquircle>
        </div>

        <div className={styles.bottomGroup} data-testid="derby-result-bottom">
          <DerbyResultCard derby={derby} />

          <Squircle asChild cornerRadius={RADIUS.xl}>
            <button type="button" className={styles.ctaButton} onClick={onClose} data-testid="derby-result-ok">
              Ок
            </button>
          </Squircle>
        </div>
      </div>
    </div>
  );
}
